import { render, staticRenderFns } from "./GenericLoader.vue?vue&type=template&id=0ea0d4f8&scoped=true&lang=html&"
import script from "./GenericLoader.vue?vue&type=script&lang=js&"
export * from "./GenericLoader.vue?vue&type=script&lang=js&"
import style0 from "./GenericLoader.vue?vue&type=style&index=0&id=0ea0d4f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea0d4f8",
  null
  
)

export default component.exports